export default {
    "hired-products": "Hired products",
    products: "Products",
    "other-rock-products": "Other Rock Content products",
    "no-offers": "No offers available",
    "renewal-date": "Renewal date",
    "you-dont-have": "You don't have",
    yet: "yet",
    open: "Open",
    "studio-description": "A marketing management solution for seamless collaboration.",
    "university-description": "Develop your Content and Digital Marketing Skills.",
    "stage-description": "Hassle-free WordPress solution for enterprise marketers",
    "gtn-description": "Expand your skills and develop your career while working for the best brands through the Rock Content platform",
    "ion-description": "Break through the noise with Interactive Content.",
    "live-description": "Maximize the results of your Lives with tailor-made live experiences.",
};
